var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedTrafficFineNotificationIntroduce5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3C2.42893 3 0.75 4.67895 0.75 6.75V8.25H23.25V6.75C23.25 4.67895 21.5711 3 19.5 3H4.5Z",
    fill: "#EB5C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 9.75H0.75V17.25C0.75 19.321 2.42893 21 4.5 21H19.5C21.5711 21 23.25 19.3211 23.25 17.25V9.75ZM8.625 16.5C8.625 16.9142 8.28923 17.25 7.875 17.25H4.875C4.46077 17.25 4.125 16.9142 4.125 16.5C4.125 16.0858 4.46077 15.75 4.875 15.75H7.875C8.28923 15.75 8.625 16.0858 8.625 16.5Z",
    fill: "#EB5C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedTrafficFineNotificationIntroduce5);
export default __webpack_public_path__ + "static/media/AutomatedTrafficFineNotificationIntroduce5.5f2c184abacd018419bb4f7b1ba33b48.svg";
export { ForwardRef as ReactComponent };